import React, { useState, useEffect, useCallback } from 'react';
import { SERVER_URL, CUTOFF_DATE } from '../../../constants.js'
import '../BookingCard.css';
import EditBooking from '../../AddsEdits/Student/EditBooking.js';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { Delete } from '@mui/icons-material';
import { formatLocalDateOnly } from '../../shared utils/dateFormatters.js';
import BespokeEventDialog from '../../shared utils/BespokeEventDialog.jsx';


function StudentBookings(props) {
  const { selectedPerson, showFinancials, selectedStay } = props;
  const [bookings, setBookings] = useState([]);
  const [bespokeOpen, setBespokeOpen] = useState(false);
  
  const fetchBookings = useCallback(() => {
    const token = sessionStorage.getItem('bearer');
    fetch(`${SERVER_URL}api/student/${selectedPerson.id}/booking`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (response.status === 204) {
          return [];
        } else if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to fetch bookings');
        }
      })
      .then((data) => {
        const filteredData = data.filter(booking => 
          booking.startDate === null || new Date(booking.startDate) > new Date(CUTOFF_DATE)
        );
        sessionStorage.setItem('bookings', JSON.stringify(filteredData));
        setBookings(filteredData);
      })
      .catch((err) => console.error(err));
  }, [selectedPerson.id]);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

    const sortedBookings = bookings.sort((a, b) => {
    return new Date(a.startDate) - new Date(b.startDate);
  });
  
  const editBooking = (booking, id) => {
    
    const customBooking = {
      ...booking,
      customStart: formatLocalDateOnly(booking.startDate),
      customEnd: formatLocalDateOnly(booking.endDate)
    };

    const token = sessionStorage.getItem("bearer"); 
    fetch(`${SERVER_URL}api/bookings/${id}`,
      { method: 'PUT', headers: {
        'Content-Type':'application/json',
        'Authorization' : `Bearer ${token}`
      },
      body: JSON.stringify(customBooking)
    })
    .then(response => {
      if (response.ok) {
        fetchBookings();
      }
      else {
        alert('Something went wrong!');
      }
    })
    .catch(err => console.error(err))
  }
 
  // Book this student onto a freshly-created bespoke EVENT product (Phase 2).
  const bookBespokeEvent = async ({ productId, perHead }) => {
    const token = sessionStorage.getItem("bearer");
    const res = await fetch(
      `${SERVER_URL}api/bookings/studentId/${selectedPerson.id}/productId/${productId}`,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ actualCharge: perHead, bookingStatus: "PROVISIONAL" }),
      }
    );
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(text || `Failed to book the event (${res.status})`);
    }
    fetchBookings();
  };

  const deleteBooking = (event, booking) => {
    event.preventDefault();

    const token = sessionStorage.getItem("bearer");

    fetch(`${SERVER_URL}api/bookings/${booking}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      method: 'GET'
    })
     .then(response => response.json())
    .then(data => {
      const productId = data.productId;

      return fetch(`${SERVER_URL}api/bookings/${booking}/product/${productId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        method: 'DELETE'
      });
    })
    .then(response => {
      if (response.ok) {
        fetchBookings();
      } else {
        alert('Something went wrong!');
      }
    })
    .catch(err => console.error(err));
  };
      
  return(
    <React.Fragment>
    <div style={{ color: '#999999', fontSize: '10px' }}>
        <p>
          Selected Student: {selectedPerson.id} — 
          Selected Stay: {selectedStay ? `${selectedStay.arrivalDate} to ${selectedStay.departureDate}` : 'None'}
        </p>
    </div>
    {showFinancials && (
      <div style={{ width: '80%', margin: '0 auto', textAlign: 'right' }}>
        <Button variant="outlined" size="small" onClick={() => setBespokeOpen(true)}>
          Add bespoke event
        </Button>
      </div>
    )}
    <div className="detail-card booking-card" style={{ padding: '20px 0' }}>
    <table style={{ width: '80%', textAlign: 'left', margin: 'auto', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Product Name</th>
            <th>Start Date</th>
            <th>End Date</th>
            {showFinancials && <th>Default Rate</th>}
            {showFinancials && <th>Actual Charge</th>}
            <th>Booking Status</th>
            <th>Booking Notes</th>
          </tr>
        </thead>
        <tbody>
          {sortedBookings.map((booking) => (
            <tr key={booking.bookingId}>
              <td>{booking.bookingId}</td>
              <td>{booking.productName}</td>
              <td>{formatLocalDateOnly(new Date(booking.startDate))}</td>
              <td>{formatLocalDateOnly(new Date(booking.endDate))}</td>
              {showFinancials && <td>{booking.defaultRate}</td>}
              {showFinancials && <td>{booking.actualCharge}</td>}
              <td>{booking.bookingStatus}</td>
              <td>{booking.notes}</td>
              <td>
                <EditBooking passedBooking={booking} editBooking={editBooking}  showFinancials={props.showFinancials}/>
              </td>
              <td>
              <IconButton onClick={(event) => deleteBooking(event, booking.bookingId)}><Delete color="primary"/></IconButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div>
        <p style={{ color: '#999999', fontSize: '10px' }}>Student: {selectedPerson.id}</p>
        <p style={{ color: '#999999', fontSize: '10px' }}>Is authenticated: {sessionStorage.getItem('isAuthenticated').toString()}</p>
      </div>
    <BespokeEventDialog
      open={bespokeOpen}
      onClose={() => setBespokeOpen(false)}
      defaultCampus={selectedStay?.campus || ''}
      defaultDate={selectedStay?.arrivalDate}
      onBook={bookBespokeEvent}
    />
    </React.Fragment>
);
}

export default StudentBookings;
